import ConversationUpdater from 'actions/conversation/lib/conversation_updater';
import CustomerView from 'models/location/customer_view';
import { getOfferedSessionForAgent } from './session_finder';
import RoutingEventType from 'models/routing_event/routing_event_type';
import SystemNotificationGenerator from 'scripts/domain/contracts/system_notification_generator';

export default class AcceptConcurrentMessagingSession extends ConversationUpdater {
  run() {
    const currentAgentId = this.currentAgent.id;
    let offeredSession = getOfferedSessionForAgent(this.context.stores.activeSessions, currentAgentId);
    if (!offeredSession) {
      return;
    }

    this.context.capacityManager.postponeMessagingRouting();

    offeredSession.accept(currentAgentId);

    this.context.stores.activeSessions.replace(offeredSession);

    this.context.gateways.routingEvent.publish(currentAgentId, {
      queueItemId: offeredSession.id,
      type: RoutingEventType.ACCEPTED_OFFERED_CONCURRENT_SESSION,
    });

    SystemNotificationGenerator.closeNotification(offeredSession.id);

    let customerView = CustomerView.create({
      currentConversationId: offeredSession.queueItem.conversationId,
      customerId: offeredSession.customer.id,
    });
    this.context.router.navigateTo(customerView);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/concurrent_messaging/accept_concurrent_messaging_session.js